export default "__VITE_ASSET__ByZ4L1lY__"